import {isEmpty} from 'lodash';
import {push} from 'react-router-redux';

import IndicativeSellingPriceValidator from '../lib/IndicativeSellingPriceValidator';
import FewerComparablesReasonValidator from '../lib/FewerComparablesReasonValidator';
import {updateIndicativeSellingPrice} from '../ducks/indicativeSellingPrice';
import {updateFewerComparablesReason} from '../ducks/fewerComparablesReason';
import {MIN_SOI_COMPARABLES} from '../constants/soi';

export default function navigateToFinalise(propertyId) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      reportType: {value: reportTypeValue},
      indicativeSellingPrice,
    } = state;

    if (reportTypeValue === 'soi') {
      let errors = IndicativeSellingPriceValidator.validate(indicativeSellingPrice);

      const {
        featureFlags = {},
        comparableSales = {},
        fewerComparablesReason = {},
      } = state;
      const selectedCount = (comparableSales.selected || []).length;
      const fewerComparablesVisible =
        !!featureFlags.propertyPriceStatement && selectedCount < MIN_SOI_COMPARABLES;
      const fewerComparablesErrors = fewerComparablesVisible
        ? FewerComparablesReasonValidator.validate(fewerComparablesReason)
        : {};

      if (isEmpty(errors) && isEmpty(fewerComparablesErrors)) {
        dispatch(push(`/properties/${propertyId}/${reportTypeValue}/finalise`));
      }

      dispatch(updateIndicativeSellingPrice({errors}));
      dispatch(updateFewerComparablesReason({errors: fewerComparablesErrors}));
    } else {
      dispatch(push(`/properties/${propertyId}/${reportTypeValue}/finalise`));
    }
  };
}
